import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Chip,
  CircularProgress,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import TopNavBar from "../components/TopNavBar";
import { useNavigate } from "react-router-dom";
import { getRouteTemplates } from "../api/routeTemplates";

export default function ConfigureRoutesPage() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getRouteTemplates()
      .then((data) => setTemplates(data.templates || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <TopNavBar heading="Konfigurer ruter" />
      <Container maxWidth="lg" sx={{ mt: 3, pb: 4 }}>
        <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1.5 }}>
          <RouteOutlinedIcon sx={{ color: "text.secondary" }} />
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Rute-skabeloner
          </Typography>
        </Box>

        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {!loading && !error && templates.length === 0 && (
          <Typography color="text.secondary">
            Ingen rute-skabeloner fundet.
          </Typography>
        )}

        {!loading && !error && templates.length > 0 && (
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              overflow: "hidden",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#f8fafc" }}>
                  <TableCell sx={{ fontWeight: 700 }}>Skabelon</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Kunde</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Lokation</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">
                    Ruter
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">
                    Rum
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="center">
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {templates.map((tpl) => (
                  <TableRow
                    key={tpl.pk_id}
                    hover
                    sx={{ cursor: "pointer" }}
                    onClick={() => navigate(`/configure-routes/${tpl.pk_id}`)}
                  >
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {tpl.template_name}
                      </Typography>
                    </TableCell>
                    <TableCell>{tpl.customer_name || "—"}</TableCell>
                    <TableCell>{tpl.location_name || "—"}</TableCell>
                    <TableCell align="center">
                      {tpl.routes_count ?? 0}
                    </TableCell>
                    <TableCell align="center">
                      {tpl.route_rooms_count ?? 0}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={tpl.active ? "Aktiv" : "Inaktiv"}
                        size="small"
                        color={tpl.active ? "success" : "default"}
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}
      </Container>
    </>
  );
}
